<div class="validate-email" role="region" aria-labelledby="emailFormTitle">
  <h2 id="emailFormTitle" class="sr-only">{{ 'PAGES.AUTH.VALIDATE_EMAIL.TITLE' | translate }}</h2>
  <form #form [formGroup]="formGroup" (ngSubmit)="handleClickOnSubmit($event)" aria-describedby="formDescription">
    <div class="email-form__sections">
      <div [hidden]="isSubmitting" class="email-form__fields">
        <div class="email-form__field">
          <label class="input-label" [for]="config.name">
            {{ config.label | translate }}
          </label>
          <div class="email-form__field__container">
            <input
              class="input-email"
              [ngClass]="{ hint: config.hintToggle }"
              [id]="config.name"
              name="{{ config.name }}"
              type="email"
              formControlName="{{ config.name }}"
              placeholder="{{ config.placeholder | translate }}"
              test-target="input-email"
              [appNoSpaces]="config.noSpaces"
              aria-required="true"
              [attr.aria-invalid]="formGroup.controls[config.name].invalid && formGroup.controls[config.name].touched"
              [attr.aria-describedby]="'error-' + config.name"
            />
          </div>
          <span
            *ngIf="formGroup.controls[config.name].touched && formGroup.controls[config.name].invalid"
            class="email-form__error"
            [id]="'error-' + config.name"
            role="alert"
          >
            {{ formGroup.controls[config.name].errors | errorMessage: config.name }}
          </span>
        </div>
      </div>
      <div class="email-form__actions">
        <button
          class="email-form__action"
          type="submit"
          test-target="email-form__submit"
          [disabled]="formGroup.invalid || isSubmitting"
          attr.aria-busy="{{ isSubmitting }}"
        >
          <div class="button-container">
            <div *ngIf="!isSubmitting">{{ config.submitText | translate }}</div>
            <div *ngIf="isSubmitting" class="email-form__spinner__container" aria-live="polite">
              <mm-spinner size="24" color="white"></mm-spinner>
            </div>
          </div>
        </button>
      </div>
    </div>
  </form>
</div>
